import { api, ApiRequestConfig } from '../../api';
import { ModelJson } from './types';

type TFetchModel = {
	pathname: string;
	region: string;
	lang?: string;
};

export const fetchPageModel = (
	url: string,
	params: TFetchModel,
	config?: ApiRequestConfig
): Promise<ModelJson> => api.get(url, params, config);
